import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>
        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link className="navbar-link" to="/">HOME</Link>
          <Link className="navbar-link" to="/portfolio">PORTFOLIO</Link>
          <Link className="navbar-link" to="/globe">GLOBE</Link>
          <Link className="navbar-link" to="/contact">CONTACT</Link>
          <Link className="navbar-link" to="/about">ABOUT</Link>
        </div>
      </div>
    </nav>
  );
}
